/**
 * Combine all reducers in this file and export the combined reducers.
 */

import { combineReducers } from '@reduxjs/toolkit';

// import { reducer as languageProviderReducer } from 'containers/LanguageProvider/slice';
import  post  from  './slices/postSlice'
import  affiliate  from  './slices/affiliateSlice'
import token from './slices/tokenSlice'
import application from './slices/applicationSlice';
import modalStatus from  './slices/modalStatusSlice'
import bonus from './slices/bonusSlice'
import commission from './slices/commissionSlice'

/**
 * Merges the main reducer with the router state and dynamically injected reducers
 */
export default function createReducer(injectedReducers = {}) {
  const rootReducer = combineReducers({
    post,
    affiliate,
    token,
    application,
    modalStatus,
    bonus,
    commission,
    ...injectedReducers,
  })

  return rootReducer;
}